export const ALBUM = [
  {
    id: "album_01",
    type: "album",
    featured: true,
    title: "Calling",
    link: "calling",
    playlistBg: "rgb(255, 102, 0)",
    imgUrl: "/image/disco/calling.jpg",
    hoverColor: "rgb(255, 102, 0)",
    artist: "alibhtty",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "https://instagram.com/ali.bhtty/",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Calling (Ali Bhtty Remix)",
        songimg: "../image/disco/calling.jpg",
        songArtist: "Jalen ft. Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/e4y32w713qjcekj/1-01%20Calling%202%20%28feat.%20Ali%20Bhtty%29.m4a",
        trackTime: "4:12",
        promo: "../image/set/ali-palosanto.jpg",
        promoCategory: 1
      },
      {
        id: "2",
        songName: "Calling",
        songimg: "../image/disco/calling-o.jpg",
        songArtist: "Jalen",
        artistLink: "jalen",
        link: "https://dl.dropbox.com/s/p6c083jsb53ow3k/1-01%20CALLING.m4a",
        trackTime: "2:55"
      }
    ]
  },
  {
    id: "album_02",
    type: "album",
    featured: true,
    title: "Cage Script",
    link: "cage-script",
    playlistBg: "rgb(136, 157, 207)",
    imgUrl: "/image/disco/cage-script.jpg",
    hoverColor: "rgb(136, 157, 207)",
    artist: "mixtape",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "calling",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Be Mine",
        songimg: "../image/disco/cage-script.jpg",
        songArtist: "K?d",
        artistLink: "kid",
        link: "https://dl.dropbox.com/s/bsxoax5xyoqcnfj/09%20-%20BE%20MINE.mp3",
        trackTime: "4:57",
        promo: "../image/set/ali-palosanto3.jpg",
        promoCategory: 1
      },
      {
        id: "2",
        songName: "Three in the morning",
        songimg: "../image/disco/cage-script.jpg",
        songArtist: "K?d",
        artistLink: "kid",
        link: "https://dl.dropbox.com/s/7okhtbw1ach604z/04%20-%20THREE%20IN%20THE%20MORNING.mp3",
        trackTime: "2:51"
      },
      {
        id: "3",
        songName: "Home Player",
        songimg: "../image/disco/cage-script.jpg",
        songArtist: "K?d",
        artistLink: "kid",
        link: "https://dl.dropbox.com/s/bxdbj90s18qoz0g/10%20-%20HOME%20PRAYER.mp3",
        trackTime: "3:41"
      }
    ]
  },
  {
    id: "album_03",
    type: "album",
    title: "MDLR",
    link: "mdlr",
    playlistBg: "rgb(0, 102, 150)",
    imgUrl: "../image/disco/mdlr.jpg",
    hoverColor: "rgb(0, 102, 150)",
    artist: "alibhtty",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "https://instagram.com/ali.bhtty/",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Que viene el Álbum (MDLR)",
        songimg: "../image/disco/mdlr.jpg",
        songArtist: "Morad, Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/scl/fi/v972aknctq9kzkbyidgnp/Que-viene-el-lbum-MDLR-Morad-alibhtty-remix.mp3?rlkey=30fz6tinl9krmjemapp4ahc43&dl=1",
        trackTime: "6:02",
        promo: "../image/set/ali-palosanto.jpg",
        promoCategory: 1
      },
    ]
  },
  {
    id: "album_04",
    type: "album",
    title: "Glittertape",
    link: "glittertape",
    playlistBg: "rgb(150,20,80)",
    imgUrl: "/image/set/glittertape.jpg",
    hoverColor: "rgb(150,20,80)",
    artist: "camoufly",
    artistImgUrl: "../image/djs/mixtape/mixtape.png",
    artistBio: "Follow",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Glittertape 8",
        songimg: "/image/set/glittertape.jpg",
        songArtist: "Camoufly",
        artistLink: "camoufly",
        link: "https://dl.dropbox.com/scl/fi/txvrpznvxejs7bnlz96rs/glittertape-8.mp3?rlkey=w0irveeok4okv18z8z8u004q9&dl=1",
        trackTime: "29:42"
      }
    ]
  },
  {
    id: "album_05",
    type: "album",
    title: "Estamos Solos",
    link: "estamos-solos",
    playlistBg: "rgba(99, 132, 87, 1)",
    imgUrl: "../image/djs/nerz/nerz.jpg",
    hoverColor: "rgba(99, 132, 87, 1)",
    artist: "Mixtape",
    artistImgUrl: "../image/djs/nerz/nerz.jpg",
    artistBio: "Follow",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Estamos Solos",
        songimg: "../image/djs/nerz/nerz.jpg",
        songArtist: "Nerz",
        artistLink: "nerz",
        link: "https://dl.dropbox.com/scl/fi/ha36bpbaiikbt5no4fdlo/ESTAMOS-SOLOS.-MC.NERZ.mp3?rlkey=pm24ku7is2q74mqo3mlszd9pf&dl=1",
        trackTime: "3:10"
      }
    ]
  },
]  